import { formatUrl } from 'url-lib';
import { sdkRequest, dangerouslyFetchAllPages } from '@eb/http';
import { deepKeysToCamel } from '@eb/transformation-utils';

import { ATTENDEE_ACCESS_PUBLIC, ATTENDEE_ACCESS_PRIVATE } from '../constants';

// extras contains the following optional parameters for fetching structured content:
// - start_date_utc: the UTC start date in UTC of the event instance (for repeating events)
// - event_date_utc: the UTC end date of the event instance (for repeating events)
// - ticket_classes: the list of ticket classes to check module display restrictions against
export const fetchEventStructuredContentUrl = (eventId, extras = {}) =>
    formatUrl(`/api/v3/events/${eventId}/structured_content/`, {
        purpose: 'digital_content',
        ...extras,
    });

export const fetchEventStructuredContentApi = async (eventId, extras) =>
    dangerouslyFetchAllPages(
        fetchEventStructuredContentUrl(eventId, extras),
        'modules',
    );

export const fetchPrivacySettings = async (eventId, extras) => {
    const {
        accessType = ATTENDEE_ACCESS_PRIVATE,
        modules,
        pagination = {},
    } = await sdkRequest(fetchEventStructuredContentUrl(eventId, extras));

    return deepKeysToCamel({ accessType, pagination, modules });
};
